/* eslint-disable no-console */
import React from 'react';

import { SiteUrlsProps } from '~src/app/selectors/SiteUrlsSelectors';
import {
  EditPublishedConnectionEntityAction,
} from '~src/app/spaces/ActionsMenu/EntityActions/EditPublishedConnectionEntityAction';
import { ItemDescription } from '~src/app/spaces/Header/HeaderItemDescription';
import { ExtractStatusMetadata, ModifiedDateMetadata, OwnerMetadata, PublishedConnectionPolicyMetaData } from '~src/app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '~src/app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/app/spaces/Header/SpaceHeader';
import { sanitize } from '~src/commonInfra/utils/Sanitize';
import { isPublishedConnectionTableInfo } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';
import { IPublishedConnectionActions } from '~src/ts/ServerApi/types/IPublishedConnectionActions';

export interface PublishedConnectionSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'publishedConnection'>;
  readonly availableActions: IPublishedConnectionActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PublishedConnectionSpaceHeader(props: PublishedConnectionSpaceHeaderProps): JSX.Element {
  const tagUrl = React.useCallback((tag: string) => props.urls.publishedConnectionsWithTagUrl(tag), [props.urls]);

  return (
    <ConnectedSpaceHeader
      item={props.itemInfo}
      availableActions={{...props.availableActions}}
      nameRowIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.itemInfo,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.itemInfo)}
        </React.Fragment>
      }
      metadataRow={
        <React.Fragment>
          {OwnerMetadata(props.itemInfo.owner, props.urls)}
          {ModifiedDateMetadata(props.itemInfo.updatedAt)}
          {ExtractStatusMetadata(props.itemInfo.hasExtracts)}
          {isPublishedConnectionTableInfo(props.itemInfo) && PublishedConnectionPolicyMetaData(props.itemInfo)}
        </React.Fragment>
      }
      spotlightActions={[EditPublishedConnectionEntityAction]}
      descriptionElement={ItemDescription(props.itemInfo, props.openDetail, sanitize)}
    />
  );
}
